import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAuthHeaders } from "../../utils/apiHeaders";

var API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export var fetchProfile = createAsyncThunk(
  "profile/fetchProfile",
  async function (language, thunkApi) {
    try {
      var response = await fetch(API_BASE_URL + "/profile", {
        method: "GET",
        signal: thunkApi.signal,
        headers: getAuthHeaders(language),
      });

      var responseData = await response.json();

      if (!response.ok) {
        return thunkApi.rejectWithValue(
          responseData.message || "Unable to retrieve profile"
        );
      }

      return responseData.data;
    } catch (error) {
      return thunkApi.rejectWithValue(
        error.message || "Unable to connect to the server"
      );
    }
  }
);

export var updateProfile = createAsyncThunk(
  "profile/updateProfile",
  async function (payload, thunkApi) {
    try {
      var language = payload.language;
      var response = await fetch(API_BASE_URL + "/profile", {
        method: "POST",
        signal: thunkApi.signal,
        headers: Object.assign(
          { "Content-Type": "application/json" },
          getAuthHeaders(language)
        ),
        body: JSON.stringify(payload.data),
      });

      var responseData = await response.json();

      if (!response.ok) {
        return thunkApi.rejectWithValue(
          responseData.message || "Unable to update profile"
        );
      }

      return responseData.data;
    } catch (error) {
      return thunkApi.rejectWithValue(
        error.message || "Unable to connect to the server"
      );
    }
  }
);

var initialState = {
  profile: null,
  loading: false,
  error: "",

  updateLoading: false,
  updateError: "",
};

var profileSlice = createSlice({
  name: "profile",
  initialState: initialState,
  reducers: {},
  extraReducers: function (builder) {
    builder
      .addCase(fetchProfile.pending, function (state) {
        state.loading = true;
        state.error = "";
      })
      .addCase(fetchProfile.fulfilled, function (state, action) {
        state.loading = false;
        state.profile = action.payload;
      })
      .addCase(fetchProfile.rejected, function (state, action) {
        state.loading = false;
        state.error = action.payload || "Unable to retrieve profile";
      })

      .addCase(updateProfile.pending, function (state) {
        state.updateLoading = true;
        state.updateError = "";
      })
      .addCase(updateProfile.fulfilled, function (state, action) {
        state.updateLoading = false;
        state.profile = action.payload;
      })
      .addCase(updateProfile.rejected, function (state, action) {
        state.updateLoading = false;
        state.updateError = action.payload || "Unable to update profile";
      });
  },
});

export default profileSlice.reducer;
